<template>
  <div class="atcclswipe">
    <el-carousel
      arrow="never"
      indicator-position="none"
      :interval="5000"
      ref="atcclswipe"
      trigger="click"
      height="390px"
    >
      <el-carousel-item v-for="(item,index) in swi" :key="index" @click.native="tojump(item)">
        <div class="atcswiitem">
          <div class="problem flex_start">
            <div class="cove">
              <img :src="item.avatar" alt="" />
            </div>
            <div class="des ">
              <div class="probdes FontGray">{{item.title}}</div>
              <div class="problay FontGray1">XX律师</div>
              <div class="FontGray1">XXXXXXXX律师事务所</div>
            </div>
          </div>
          <div class="answer">
            <div class="title">律师回答</div>
            <div class="desc">
              {{item.content | toEllipsisFilter(90)}}
            </div>
            <!-- <div class="title">法律依据</div>
            <div class="desc">
              《公务员录用规定》第十九条 <br />
              《公务员录用规定》第十九条
            </div> -->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="operation between">
      <div class="prev center" @click="prev">
        <svg-icon
          icon-class="jt_right"
          class="flip180"
        ></svg-icon>
      </div>
      <div class="next center" @click="next">
        <svg-icon icon-class="jt_right"></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      swi:[]
    }
  },
  beforeMount(){
    this.getarticlist()
  },
  methods: {
    prev() {
      this.$refs.atcclswipe.prev();
    },
    next() {
      this.$refs.atcclswipe.next();
    },
    tojump(item){
      console.log(item);
      this.$router.push({
        path:'/laws/articimdet',
        query: {
          articinId: item.id,
        },
      })
    },
    
    getarticlist() {
      let data = {
        limit: 6,
        page: 1,
        order:'hot'
      };
      this.$http.laws.getarticlist(data).then((res) => {
        this.swi = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.atcclswipe {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  position: relative;
  .atcswiitem {
    position: relative;
    .problem {
      width: 676px;
      height: 390px;
      padding: 82px 62px;
      align-items: flex-start;
      background: url(../../../assets/findlawyers/bg007.png);
      .cove {
        img {
          width: 110px;
          height: 110px;
          border-radius: 50%;
        }
      }
      .des {
        font-size: 26px;
        color: #ffffff;
        width: 360px;
        margin-left: 32px;
        .probdes {
          font-size: 28px;
          line-height: 36px;
          position: relative;
          padding-bottom: 26px;
          &::after {
            content: "";
            position: absolute;
            bottom: -0;
            left: 0;
            width: 78px;
            height: 3px;
            background: #999999;
          }
        }
        .problay {
          margin: 23px 0;
        }
      }
    }
    .answer {
      position: absolute;
      right: 0;
      top: 70px;
      width: 604px;
      height: 250px;
      padding: 0 38px;
      background: #fff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
      border-right: 1px solid rgba(0, 0, 0, 0.04);
      .title {
        font-size: 24px;
        color: #333333;
        line-height: 42px;
        margin-top: 20px;
      }
      .desc {
        font-size: 16px;
        color: #999999;
        line-height: 26px;
      }
    }
  }
  .operation {
    position: absolute;
    bottom: 55px;
    right: 25px;
    z-index: 3;
    width: 108px;
    .prev,
    .next {
      width: 42px;
      height: 42px;
      background: #f2f2f2;
      border-radius: 50%;
      color: #999999;
      &:hover {
        background-color: #0465ea;
        color: #fff;
      }
    }
  }
}
</style>